import { useCurrentWorkspaceMembers } from "@api/workspaceMember.api";
import { UserAvatar } from "@components/avatar/UserAvatar";
import { getAssigneeHiddenTooltip } from "../../TaskView/Cells/assigneeHiddenTooltip";
import { TaskAvatarLabel } from "./TaskAvatarLabel";
import styles from "./TaskAssigneeLabel.module.scss";
import type { TaskListTaskRow } from "./taskRowCells";

/**
 * The task's assignee from the row's workspace members: avatar and name,
 * dimmed with the reason as its tooltip when they can't see the task.
 */
export const TaskAssigneeLabel = ({
    task,
    assigneeId,
}: {
    task: TaskListTaskRow;
    assigneeId: number;
}) => {
    const { data: members = [] } = useCurrentWorkspaceMembers();
    const assignee = members.find((member) => member.user.id === assigneeId);
    if (!assignee) {
        return null;
    }
    const hiddenTooltip = task.isNewPlaceholder
        ? undefined
        : (getAssigneeHiddenTooltip(task, assignee) ?? undefined);
    return (
        <span
            className={styles.assignee}
            data-hidden={hiddenTooltip ? "" : undefined}
            data-cell-tooltip={hiddenTooltip}
            data-cell-tooltip-always={hiddenTooltip ? "" : undefined}
        >
            <TaskAvatarLabel
                avatar={
                    <UserAvatar user={assignee.user} size="sm" aria-hidden />
                }
                label={assignee.user.name}
            />
        </span>
    );
};
